module.exports = __webpack_public_path__ + "img/zphd_icon_diamond.9ecde706.png";